import survey from "../services/engagement.survey";
import notificaton from "../services/notification";
import notification from "../services/notification";

export default {
    namespaced: true,

    state: {
        loading: false,
        error: false,
        errors: null,
        list: [],
        filters: null,
        pagination: {
            currentPage: 1,
            prevPage: 0,
            nextPage: 0,
            maxPage: 0,
            totalPerPage: 0,
            currentFirstItem: 0,
            currentLastItem: 0,
            initialPageCount: 0,
            perPage: 10
        },
        param: {
            param: {
                keyword: null,
                filter: null
            },
            page: 1
        },
        targetSegments: null,
        survey_modal: {
            new: false,
            edit: {
                status: false,
                uuid: null
            },
            delete: {
                status: false,
                uuid: null,
                title: null
            },
            view: {
                status: false,
                survey_id: null,
                target_segment_uuid: null,
                list: [],
            }
        },
        viewsurvey_pagination: {
            currentPage: 1,
            prevPage: 0,
            nextPage: 0,
            maxPage: 0,
            totalPerPage: 0,
            currentFirstItem: 0,
            currentLastItem: 0,
            initialPageCount: 0,
            perPage: 10
        }
    },

    mutations: {
        loading(state, value) {
            state.loading = value;
        },
        errors(state, errors) {
            state.error = true;
            state.errors = errors.errors;
        },
        clearErrors(state) {
            state.error = false; 
            state.errors = null;
        },
        setTargetSegments(state, targetsegments) {
            state.targetSegments = targetsegments;
        },
        setList(state, list) {
            state.list = list;
        },
        setModal(state, status) {
            switch (status.type) {
                case "edit":
                    state.survey_modal[status.type].status = status.status;
                    state.survey_modal[status.type].uuid = status.uuid;
                    break;
                case "delete":
                    state.survey_modal[status.type].status = status.status;
                    state.survey_modal[status.type].id = status.id;
                    state.survey_modal[status.type].title = status.title;
                    break;
                case "view":
                    state.survey_modal[status.type].status = status.status;
                    state.survey_modal[status.type].survey_id = status.survey_id;
                    state.survey_modal[status.type].target_segment_uuid = status.target_segment_uuid;
                    state.survey_modal[status.type].title = status.title;
                    state.survey_modal[status.type].page = status.page;
                    state.survey_modal[status.type].list = status.list;
                    break;
                default:
                    state.survey_modal[status.type] = status.status;
                    break;
            }
        },
        setInitialPageCount(state, list) {
            state.pagination.initialPageCount = list.length;
        },
        setCurrentPage(state, page) {
            state.pagination.currentPage = page;
        },
        setPagination(state, pagination) {
            state.pagination.totalPerPage = pagination.list.length;
            state.pagination.maxPage = state.pagination.totalPerPage > 0 ? pagination.max_page : 0;
            state.pagination.prevPage = pagination.prev_page;
            state.pagination.nextPage = pagination.next_page;
            state.pagination.currentPage = state.pagination.prevPage + 1;
            state.pagination.currentFirstItem =
                state.pagination.totalPerPage > 0
                    ? state.pagination.initialPageCount * state.pagination.prevPage + 1
                    : 0;
            state.pagination.currentLastItem =
                state.pagination.currentFirstItem > 0
                    ? state.pagination.currentFirstItem + state.pagination.totalPerPage - 1
                    : 0;
        },
        setViewList(state, list) {
            state.survey_modal.view.list = list;
        },
        setInitialPageCount_view(state, list) {
            state.viewsurvey_pagination.initialPageCount = list.length;
        },
        setPagination_view(state, pagination) {
            state.viewsurvey_pagination.totalPerPage = pagination.list.length;
            state.viewsurvey_pagination.maxPage = state.viewsurvey_pagination.totalPerPage > 0 ? pagination.max_page : 0;
            state.viewsurvey_pagination.prevPage = pagination.prev_page;
            state.viewsurvey_pagination.nextPage = pagination.next_page;
            state.viewsurvey_pagination.currentPage = state.viewsurvey_pagination.prevPage + 1;
            state.viewsurvey_pagination.currentFirstItem =
                state.viewsurvey_pagination.totalPerPage > 0
                    ? state.viewsurvey_pagination.initialPageCount * state.viewsurvey_pagination.prevPage + 1
                    : 0;
            state.viewsurvey_pagination.currentLastItem =
                state.viewsurvey_pagination.currentFirstItem > 0
                    ? state.viewsurvey_pagination.currentFirstItem + state.viewsurvey_pagination.totalPerPage - 1
                    : 0;
        }
    },

    actions: {
        getList: async ({ commit }, param) => {
            commit("loading", true);
            try {
                let response = await survey.getList(param);

                if (param.page === 1) {
                    await commit("setInitialPageCount", response.list);
                }

                commit("setList", response.list);
                commit("setPagination", response);
                commit("loading", false);
            } catch (errors) {
                commit("errors", errors);
                commit("loading", false);
            }
        },

        create: async ({ commit, state }, param) => {
            commit("loading", true);
            try {
                let response = await survey.create(param);
                commit("setModal", {
                    type: "new",
                    status: false
                });
                notificaton.success(response.message);
                commit("loading", false);
            } catch (errors) {
                commit("loading", false);
                commit("errors", errors);
                notificaton.warning("Oops, unable to create survey.");
            }
        },

        update: async ({ commit }, param) => {
            commit("loading", true);
            try {
                let response = await survey.update(param);
                commit("setModal", {
                    type: "edit",
                    status: false
                });
                notificaton.success(response.message);
                commit("loading", false);
            } catch (errors) {
                commit("loading", false);
                commit("errors", errors);
                notificaton.warning("Oops, unable to update survey.");
            }
        },

        getTargetSegments: async ({ commit }) => {
            try {
                let response = await survey.getTargetSegments();

                let list = response.options;
                let new_segments = []

                list.forEach(function(segment){
                    let target = {
                        text: segment.name,
                        value: segment.target_segment_uuid
                    };
                    new_segments.push(target);
                });
                commit("setTargetSegments", new_segments);
            } catch (errors) {
                commit("errors", errors);
            }
        },

        delete: async ({ commit, dispatch, state }, id) => {
            commit("loading", true)
            try {
                let response = await survey.delete(id);
                commit("setModal", {
                    type: "delete",
                    status: false
                });
                await dispatch("getList", state.param);
                notificaton.success("Survey Successfully Deleted.");
            } catch (errors) {
                commit("errors", errors);
                notification.warning("Oops, unable to delete survey.")
            }
        },

        view: async ({ commit }, param) => {
            commit("loading", true);
            try {
                let response = await survey.view({
                    survey_id: param.survey_id,
                    target_segment_uuid: param.target_segment_uuid,
                    page: param.page
                });
                if (param.page === 1) {
                    await commit("setInitialPageCount_view", response.list);
                }

                commit("setViewList", response.list);
                commit("setPagination_view", response);
                commit("loading", false);
            } catch (errors) {
                commit("errors", errors);
                commit("loading", false);
            }
        },

        export: async ({ commit }, param) => {
            commit("loading", true);
            try {
                let response = await survey.export({
                    survey_id: param.survey_id,
                    target_segment_uuid: param.target_segment_uuid
                });

                window.open(response.url);

                commit("loading", false);
            } catch (errors) {
                commit("errors", errors);
                commit("loading", false);
            }
        }
    }
}